var $ = jQuery;
var $html = $('html');
var $window = $(window);

$(function() {
    $html.addClass('js-ready');

    /**
     * Autofokus auf Geburtsjahr-Eingabe auf der Startseite
     */
    $('body.home').find('input[name="birthyear"]').focus();

    /**
     * Automatiche Punkte in einem Datums-Eingabefeld
     */
    var adjustDateInput = function () {
        var $input = $(this);
        var value = $input.val();
        var dotCount = value.split('.').length - 1;

        // .. verhindern
        if (value.substr(-2) === '..') {
            value = value.substr(0, value.length - 1);
            dotCount = value.split('.').length - 1;
            $input.val(value);
        }

        // z.B. 41 => 04.1
        if (dotCount === 0 && value.length === 2 && parseInt(value) > 31) {
            value = '0' + value.substr(0, 1) + '.' + value.substr(1);
            $input.val(value);
            dotCount = 1;
        }

        // z.B. 123 => 12.3
        if (dotCount === 0 && value.length === 3) {
            value = value.substr(0, 2) + '.' + value.substr(2);
            $input.val(value);
            dotCount = 1;
        }

        // z.B. 1. => 01.
        if (dotCount === 1 && value.length === 2) {
            value = '0' + value;
            $input.val(value);
        }

        // z.B. 01.2 => 01.02.
        if (dotCount === 1 && value.length === 4 && parseInt(value.substr(3)) > 1) {
            value = value.substr(0, 3) + '0' + value.substr(3) + '.';
            $input.val(value);
            dotCount = 2;
        }

        // z.B. 01.41 => 01.04.1
        if (dotCount === 1 && value.length === 5 && parseInt(value.substr(3)) > 12) {
            value = value.substr(0, 3) + '0' + value.substr(3, 1) + '.' + value.substr(4);
            $input.val(value);
            dotCount = 2;
        }

        // z.B. 01.041 => 01.04.1
        if (dotCount === 1 && value.length === 6) {
            value = value.substr(0, 5) + '.' + value.substr(5);
            $input.val(value);
            dotCount = 2;
        }

        // z.B. 12.2. => 12.02.
        if (dotCount === 2 && value.length === 5) {
            value = value.substr(0, 3) + '0' + value.substr(3);
            $input.val(value);
        }
    };
    $(document).on('keyup', 'input.date-input', adjustDateInput);

    // Eingabefelder für den Namen der zu versicherten Person ein-/ausblenden
    if ($('body').hasClass('request')) {
        var toggleInsureName = function() {
            if ($('input[name="insure"]:checked').val() == 'other') {
                $('#insureName').show();
                $('#customer-birthday-group').show();
            } else {
                $('#insureName').hide();
                $('#customer-birthday-group').hide();
            }
        };
        $('input[name="insure"]').change(toggleInsureName);
        toggleInsureName();
    }

    /**
     * Einblenden der Tarifbedingungen beim Klick auf dem „Angebot anfordern“
     * Button
     */
    $(document).on('click', 'li.not-finishable a.btn-request', function (e) {
        e.preventDefault();
        $(this).parents('li').addClass('show-conditions');
    });

    /**
     * Estimate tariff
     */
    var $formEstimateTariff = $('form.estimate-tariff');
    var $inputBirthday = $('input[name="birthday"]', $formEstimateTariff);
    $inputBirthday.on('focus', function() {
        var $form = $(this).parents('form');
        var $priceContainer = $('.estimated-price', $form);
        $priceContainer.addClass('empty');
        $priceContainer.html('');
        $form.removeClass('price-calculated');

        var $btn = $('.btn-primary', $form);
        $btn.addClass('btn-estimate');
        $btn.removeClass('btn-request');
        $btn.html('Monatsbeitrag berechnen');
    });
    var updatePrice = function($form) {
        var $priceContainer = $('.estimated-price', $form);
        var url = $form.attr('action');
        var buttonLabel = 'Infopaket anfordern';

        if ($form.find('input[name="compare"]').val() === '1') {
            buttonLabel = 'Tarife vergleichen';
        }

        $form.removeClass('price-calculated');
        $priceContainer.addClass('loading');
        $priceContainer.removeClass('empty');
        $priceContainer.html('Wird berechnet…');
        $.post(url, $form.serialize(), function(data) {
            $priceContainer.removeClass('loading');

            if (!data || !data.price) {
                $priceContainer.html('');
                $priceContainer.addClass('empty');
                $inputBirthday.addClass('has-error');
                $inputBirthday.focus();
            } else {
                $form.addClass('price-calculated');
                $priceContainer.html(data.price);
                $priceContainer.removeClass('empty');
                $inputBirthday.removeClass('has-error');

                var $btn = $('.btn-primary', $form);
                $btn.removeClass('btn-estimate');
                $btn.addClass('btn-request');
                $btn.html(buttonLabel);
            }
        }, "json");
    };
    $inputBirthday.on('change blur', function() {
        updatePrice($(this).parents('form'));
    });
    $formEstimateTariff.on('submit', function(e) {
        if ($('.btn-estimate', $(this)).length) {
            e.preventDefault();
            updatePrice($(this));
        }
    });

    /**
     * Rechner-Funktionen aktivieren
     */
    $('.calculator').find('form').formCalculator();
    $('form.calculator').formCalculator();

    /**
     * Toggle „Telefonische Erreichbarkeit“
     */
    var $phoneConsultation = $('input[name="phoneConsultation"]');
    var togglePhoneTime = function (disableAnimation) {
        var duration = disableAnimation === true ? 0 : 400;
        var $group = $('#phone-time-group');
        var phoneConsultation = $('input[name="phoneConsultation"]:checked').val();

        if (phoneConsultation === '1') {
            $group.slideDown(duration);
        } else {
            $group.slideUp(duration);
        }
    };
    $phoneConsultation.on('change', togglePhoneTime);
    togglePhoneTime(true);

    /**
     * Toggle filter
     */
    $('#btn-filter').on('click', function() {
        $('#filter').slideToggle();
        $(this).toggleClass('active');
    });

    /**
     * Open unsuitable tariffs
     */
    $(document).on('click', '.unsuitable.inactive .btn-open', function (e) {
        e.preventDefault();
        $(this).parents('.unsuitable').removeClass('inactive');
        $(this).remove();

        $(window).scrollTop($(window).scrollTop() + 1);
    });

    /**
     * Automatisch zum Fehler springen
     */
    var $error = $('body.request').find('.error-msg');
    if ($error.length) {
        $(window).scrollTop($error.offset().top - 50);
    }
});
